export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-50">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14 bg-gradient-to-br from-primary-500/[0.06] to-accent-500/[0.04] rounded-2xl p-8 md:p-12 lg:p-14 border border-background-200/60">
          <div className="lg:w-[360px] shrink-0 flex justify-center">
            <div className="relative">
              <img
                src="https://readdy.ai/api/search-image?query=Smartphone%20mockup%20displaying%20movie%20streaming%20app%20interface%20with%20dark%20theme%2C%20elegant%20UI%20design%20showing%20movie%20posters%20grid%2C%20clean%20minimalist%20layout%2C%20modern%20mobile%20app%20aesthetic%2C%20premium%20device%20presentation%2C%20soft%20studio%20lighting%20on%20device%2C%20professional%20product%20photography%20with%20neutral%20background&width=560&height=800&seq=app-mockup&orientation=portrait"
                alt="酷客影院移动端"
                className="w-48 md:w-56 h-auto rounded-3xl"
                loading="lazy"
              />
              <div className="absolute -bottom-2 -right-2 bg-accent-500 text-white text-xs font-bold px-3 py-1 rounded-full whitespace-nowrap">
                全新上线
              </div>
            </div>
          </div>

          <div className="flex-1 text-center lg:text-left">
            <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-accent-100 text-accent-700 mb-3 whitespace-nowrap">
              随时随地
            </span>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
              移动观影
            </h2>
            <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-6 max-w-lg">
              酷客影院移动端现已支持手机与平板访问。无论是在通勤路上、午休间隙还是睡前时光，打开浏览器即可享受与桌面端一致的高清观影体验，观影记录自动同步，断点续播无缝衔接。
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 flex-wrap">
              <div className="flex items-center gap-2 px-4 py-2.5 bg-foreground-900 text-background-50 rounded-lg text-sm font-medium whitespace-nowrap">
                <i className="ri-android-line text-lg"></i>
                Android 版
              </div>
              <div className="flex items-center gap-2 px-4 py-2.5 bg-foreground-900 text-background-50 rounded-lg text-sm font-medium whitespace-nowrap">
                <i className="ri-apple-line text-lg"></i>
                iOS 版
              </div>
              <div className="flex items-center gap-2 px-4 py-2.5 bg-background-100 text-foreground-700 rounded-lg text-sm font-medium border border-background-200 whitespace-nowrap">
                <i className="ri-qr-code-line text-lg"></i>
                扫码访问网页版
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}